import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";

import { FC, ReactNode, createContext, useEffect, useLayoutEffect, useState } from "react";

import { useSelector } from "@/store";
import { rootReducerName } from "@/store/rootReducer";

import { themeCreator } from "./base";
import {
  DEFAULT_THEME_NAME,
  THEME_BACKGROUND_BY_NAME,
  THEME_STORAGE_KEY,
  ThemeName,
  getThemeMode,
  isThemeName,
  resolveInitialThemeName
} from "./themeBootstrap";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ThemeContext = createContext((_themeName: string): void => {});
interface ThemeProviderWrapperProps {
  children: ReactNode;
}

export const ThemeProviderWrapper: FC<ThemeProviderWrapperProps> = ({ children }) => {
  const [themeName, _setThemeName] = useState<ThemeName>(() => resolveInitialThemeName());
  const currentTheme = useSelector((state) => state[rootReducerName.changeTheme].curTheme);

  useEffect(() => {
    const curThemeName = isThemeName(currentTheme) ? currentTheme : resolveInitialThemeName();
    if (curThemeName !== themeName) {
      _setThemeName(curThemeName);
    }
  }, [currentTheme, themeName]);

  useLayoutEffect(() => {
    if (typeof document === "undefined") {
      return;
    }

    const themeMode = getThemeMode(themeName);
    const themeBackground = THEME_BACKGROUND_BY_NAME[themeName];
    window.localStorage.setItem(THEME_STORAGE_KEY, themeName);
    document.documentElement.dataset.theme = themeMode;
    document.documentElement.style.backgroundColor = themeBackground;
    document.documentElement.style.colorScheme = themeMode;
    if (document.body) {
      document.body.style.backgroundColor = themeBackground;
    }
  }, [themeName]);

  const theme = themeCreator(themeName);
  const setThemeName = (themeName: string): void => {
    const resolvedThemeName = isThemeName(themeName) ? themeName : DEFAULT_THEME_NAME;
    _setThemeName(resolvedThemeName);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </ThemeContext.Provider>
    </StyledEngineProvider>
  );
};

// export default ThemeProviderWrapper;
